import store  from '@/store';

const state = {
  windowSize: { x: 0, y: 0, is_movile: true },
  legal: { fecha_nacimiento: "", mayor_edad: false, check_cookies: false },
  mainCategoryId: 0,
  openMenuTop: false,
  category_grid: null,
  seeProduct: false,
  acquisitionId: null,
  productsFilter: "all",
  product_id: null,
  navTabPos: 0,
  lang: '',
  error: {
    key: '',
    show: false,
    message: "",
    icon: "fa-light fa-circle-exclamation"
  },
  backRoute: null,
  confirmationLocation: false,
  coupon: null,
  productIdGhost: null
};

const getters = {
  acquisition_id: state => {
    return state.acquisitionId;
  },
  lang: state => {
    return state.lang;
  }
};

const actions = {};

const mutations = {
  setWindowSize(state, data) {
    if (data.x >= 980) data.is_movile = false;
    if (data.x < 980) data.is_movile = true;
    state.windowSize = data;
  },
  SetLegal(state, data) {
    if (data !== null && data !== undefined) {
      state.legal.fecha_nacimiento = data.data.fecha_nacimiento;
      state.legal.mayor_edad = data.data.mayor_edad;
    }
  },
  setMainCategory(state, data) {
    state.mainCategoryId = data;
  },
  setOpenMenuTop(state, data) {
    state.openMenuTop = data;
  },
  SetCategoryGrid(state, data) {
    state.category_grid = data;
  },
  SetSeeProduct(state, data) {
    state.seeProduct = data;
  },
  SetAcquisitionId(state, data) {
    state.acquisitionId = data;
  },
  SetProductId (state, data) {
    state.confirmationLocation = false;
    const isDelivery =
      store.state.order.service === "delivery" &&
      !store.state.order.purchaseId &&
      store.state.customer.instance.suppliers.length > 1 &&
      store.state.profile.location.address.length === 0 &&
      !store.state.profile.supplierAvailability.selected;
    if (data !== null && isDelivery) {
      state.productIdGhost = data;
      state.confirmationLocation = true;
    } else {
      state.product_id = data;
    }
  },
  setNavTabPos(state, data) {
    state.navTabPos = data;
  },
  setCookies(state, data) {
    state.legal.check_cookies = data;
  },
  setLanguage(state, data) {
    state.lang = data;
  },
  setError(state, data) {
    state.error.show = data.show;
    if (data.key) state.error.key = data.key;
    if (data.message) state.error.message = data.message;
  },
  setOpenValidateCoverge(state, data) {
    if (state.productIdGhost !== null && store.state.profile.location.place_id) {
      state.product_id = state.productIdGhost;
      state.productIdGhost = null;
    };
    state.confirmationLocation = data;
  },
  setCoupon (state, data) {
    state.coupon = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
